import { useEffect } from 'react';

import { trackEvent } from '../utils/analytics';

/**
 * Query the IP address and track the event.
 */
export const useTrackIPAddress = () => {
  useEffect(() => {
    fetch('https://api64.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => {
        if (!data?.ip) {
          return;
        }

        void trackEvent('FetchIPAddress', {
          eventLabel: 'Success',
          eventMetadata: { ip: data?.ip, isIPv6: data?.ip?.includes?.(':') },
        });
      })
      .catch((err) => {
        void trackEvent('FetchIPAddress', {
          eventLabel: 'Fail',
          eventMetadata: { error: err?.message },
        });
      });
  }, []);
};
